<template>
  <footer class="footer" id="contact">
    <div class="footer-content">
      <div class="contact-info">
        <p>Phone: <a href="tel:+13313454999">+1 (331) 345-4999</a></p>
        <p>Email: <a href="mailto:autogrield@gmail.com">autogrield@gmail.com</a></p>
      </div>
      <p class="version">v{{ version }}</p>
    </div>
  </footer>
</template>

<script setup>
const version = process.env.VUE_APP_VERSION
</script>

<style scoped>
.footer {
  background-color: #1a1a1a;
  padding: 2rem 0;
  text-align: center;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.contact-info p {
  margin: 0;
  color: #e0e0e0;
}

.contact-info a {
  color: #ffffff;
  text-decoration: none;
  transition: color 0.3s ease;
}

.contact-info a:hover {
  color: #bdbdbd;
}

.version {
  margin: 1rem 0 0;
  color: #666;
  font-size: 0.75rem;
}

@media (max-width: 768px) {
  .footer {
    padding: 1.5rem 0;
  }
  
  .footer-content {
    padding: 0 1rem;
  }
}
</style> 